import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import Invoice from './invoice';

const InvoicesView = props => (
  <div className="mt-5">
    <h2>
      <Translate value="invoices.title"/>
    </h2>
    <div className="card">
      {!props.invoices.length &&
        <>
          {props.loading && <div className="loading-overlay"/>}
          <div className="table-without-result">
            <Translate value="invoices.noResult"/>
          </div>
        </>
      }
      {props.invoices.map(invoice => <Invoice
        key={`invoice-${invoice.id}`}
        invoice={invoice}
      />)}
      {props.showButton &&
        <div className="d-flex justify-content-center mt-5">
          <button
            type="button"
            className="secondary large flex-container"
            onClick={props.onLoadMore}
            disabled={props.loading && props.invoices.length}
          >
            <Icon icon={props.loading && props.invoices.length ? 'loader' : 'folder-plus'}/>
            <Translate value="invoices.loadMore"/>
          </button>
        </div>
      }
    </div>
  </div>
);

InvoicesView.propTypes = {
  loading: PropTypes.bool,
  invoices: PropTypes.array.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  showButton: PropTypes.bool
};

export default InvoicesView;
